import fixture from './CompanySearchByNumber.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanySearchByNumberClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanySearchByNumberClient';
import { getCookie } from 'utils/cookie';
const csrfToken = getCookie('csrftoken');

export class CompanySearchByNumberClient implements ICompanySearchByNumberClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { companyNumber, mock = false } = input;

        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };
        const PATH = `${API_LOCATION_URL}/public/company_search_by_number?company_number=${companyNumber}`;
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
